import "../styles/Loader.css";

export const Loader = (): JSX.Element => {
  return <div className="loader" data-testid="loader"></div>;
};

